// @flow

import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import PuzzlePiece from './PuzzlePiece';
import DnDTypes from './types';
import type { PieceData, PlacePuzzlePiece } from './types';

type Props = {
  pieceData: PieceData,
  finished: boolean,
  connectDropTarget: (React$Element<any>) => React$Element<any>,
  placePuzzlePiece: PlacePuzzlePiece,
  fieldWidth: number,
};

type CollectData = {
  connectDropTarget: Function,
};

const putPiece = {
  drop(props: Props, monitor: any): void {
    const droppedPiece = monitor.getItem();
    props.placePuzzlePiece(props.pieceData.number, droppedPiece.pieceNumber);
  },
};

function collect(connect: any): CollectData {
  return {
    connectDropTarget: connect.dropTarget(),
  };
}

class DroppablePiece extends Component<Props> {
  render(): React$Element<any> {
    const {
      pieceData,
      finished,
      connectDropTarget,
      fieldWidth,
    } = this.props;

    const scale = fieldWidth / 470;

    return connectDropTarget(
      <figure
        style={{
          position: 'absolute',
          top: `${pieceData.pieceY * scale}px`,
          left: `${pieceData.pieceX * scale}px`,
        }}
      >
        <PuzzlePiece
          pieceData={pieceData}
          finished={finished}
          fieldWidth={fieldWidth}
          prefix="drop"
        />
      </figure>,
    );
  }
}

export default DropTarget(DnDTypes.DRAGGABLE_PIECE, putPiece, collect)(
  DroppablePiece,
);
